import { gql } from '@apollo/client';

export const SchoolRequisitesFragment = gql`
    fragment SchoolRequisites on SchoolRequisites {
        inn
        kpp
        ogrn
        address
        licence
        responsibleName
        responsiblePhone
        responsibleEmail
        signerName
        signerNameGenitive
        signerPosition
        signerPositionGenitive
    }
`;
